import React from 'react';
import StatCard from './StatCard';
import { formatPrice } from '../../utils/formatterUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHome,
    faAddressBook,
    faChartLine,
    faPercent, faEuroSign, faUser,
} from '@fortawesome/free-solid-svg-icons';

export default function Stats({ data }) {
  if (!data) return null;
  const {
    properties,
    contactsMonthly,
    contactsMonthlyTrend,
    totalRevenue,
    budgetUsed,
    revenueMonthlyTrend,
    budgetMonthlyTrend,
  } = data;
  const contactsTrendClass = contactsMonthlyTrend >= 0 ? 'trend-up' : 'trend-down';
  const contactsTrendArrow = contactsMonthlyTrend >= 0 ? '↑' : '↓';
  const revenueTrendClass = revenueMonthlyTrend >= 0 ? 'trend-up' : 'trend-down';
  const revenueTrendArrow = revenueMonthlyTrend >= 0 ? '↑' : '↓';
  const budgetTrendClass = budgetMonthlyTrend >= 0 ? 'trend-up' : 'trend-down';
  const budgetTrendArrow = budgetMonthlyTrend >= 0 ? '↑' : '↓';
  const budgetTrendValue = Math.abs(budgetMonthlyTrend).toFixed(0);

  return (
    <section className="stats" aria-label="Statistiche principali">
      <StatCard
        label="Proprietà Totali"
        value={properties.total}
        sub={`${properties.sold} vendute, ${properties.available} disponibili`}
        icon={<FontAwesomeIcon icon={faHome} />}
      />
      <StatCard
        label="Contatti Mensili"
        value={contactsMonthly}
        sub={
          <span>
            <span className={contactsTrendClass}>
              {contactsTrendArrow} {Math.abs(contactsMonthlyTrend).toFixed(0)}%
            </span>{' '}
            vs mese scorso
          </span>
        }

        icon={<FontAwesomeIcon icon={faUser} />}
      />
      <StatCard
        label="Fatturato Totale"
        value={formatPrice(totalRevenue)}
        sub={
          <span>
            <span className={revenueTrendClass}>
              {revenueTrendArrow} {Math.abs(revenueMonthlyTrend).toFixed(0)}%
            </span>{' '}
            vs mese scorso
          </span>
        }
        icon={<FontAwesomeIcon icon={faChartLine} />}
      />
      <StatCard
        label="Budget Utilizzato"
        value={`${budgetUsed.toFixed(0)}%`}
        sub={
          <span>
            <span className={budgetTrendClass}>
              {budgetTrendArrow} {budgetTrendValue}%
            </span>{' '}
            vs mese scorso
          </span>
        }
        icon={<FontAwesomeIcon icon={faEuroSign} />}
      />
    </section>
  );
}
